// ⚠️ كل القيم هنا افتراضات يجب تأكيدها مقابل الـ enums الحقيقية في Supabase.
// راجع SCHEMA_ASSUMPTIONS.md في جذر المشروع لتفاصيل كل افتراض.
// هذا الملف هو المكان الوحيد الذي يجب تعديله لو كانت القيم الحقيقية مختلفة.

export const ROLES = { OWNER: 'owner', ADMIN: 'admin', FOREMAN: 'foreman', TECHNICIAN: 'technician', TENANT: 'tenant' };
export const ROLE_LABELS_AR = { owner: 'المالك', admin: 'مدير الصيانة (المهندس)', foreman: 'فورمان', technician: 'عامل صيانة', tenant: 'مستأجر' };

export const UNIT_STATUS = { OCCUPIED: 'occupied', VACANT: 'vacant', INACTIVE: 'inactive' };
export const UNIT_STATUS_LABELS_AR = { occupied: 'مؤجرة', vacant: 'شاغرة', inactive: 'غير مستخدمة' };

export const PRIORITY = { LOW: 'low', MEDIUM: 'medium', HIGH: 'high', URGENT: 'urgent' };
export const PRIORITY_LABELS_AR = { low: 'منخفضة', medium: 'متوسطة', high: 'عالية', urgent: 'طارئة' };
export const SLA_HOURS = { low: 120, medium: 48, high: 12, urgent: 4 };

// دورة حياة التذكرة كما حدّدتها بالضبط — لم تُغيَّر
export const TICKET_STATUS = {
  NEW: 'new',
  UNDER_REVIEW: 'under_review',
  ASSIGNED_TO_FOREMAN: 'assigned_to_foreman',
  ASSIGNED_TO_TECHNICIAN: 'assigned_to_technician',
  TECHNICIAN_RECEIVED: 'technician_received',
  IN_PROGRESS: 'in_progress',
  TECHNICIAN_SOLVED: 'technician_solved',
  WAITING_FOREMAN_APPROVAL: 'waiting_foreman_approval',
  APPROVED: 'approved',
  CLOSED: 'closed',
  REOPENED: 'reopened',
  CANCELLED: 'cancelled'
};
export const TICKET_STATUS_LABELS_AR = {
  new: 'جديدة',
  under_review: 'قيد المراجعة',
  assigned_to_foreman: 'تم تحويلها للفورمان',
  assigned_to_technician: 'تم تحويلها للفني',
  technician_received: 'استلمها الفني',
  in_progress: 'قيد التنفيذ',
  technician_solved: 'تم الحل من الفني',
  waiting_foreman_approval: 'بانتظار اعتماد الفورمان',
  approved: 'تم اعتماد الحل',
  closed: 'مغلقة',
  reopened: 'أُعيد فتحها',
  cancelled: 'ملغاة'
};
export const STATUS_TONE = {
  new: 'gray', under_review: 'amber', assigned_to_foreman: 'blue', assigned_to_technician: 'blue',
  technician_received: 'blue', in_progress: 'blue', technician_solved: 'amber', waiting_foreman_approval: 'amber',
  approved: 'green', closed: 'green', reopened: 'blue', cancelled: 'red'
};

// أسماء الجداول — عدّلها هنا فقط إن كانت أسماؤك الحقيقية مختلفة
export const TABLES = {
  PROFILES: 'profiles',
  PROPERTIES: 'properties',
  UNITS: 'units',
  PROBLEM_TYPES: 'problem_types',
  TICKETS: 'tickets',
  TICKET_COSTS: 'ticket_costs',
  TICKET_TIMELINE: 'ticket_timeline',
  TICKET_ATTACHMENTS: 'ticket_attachments',
  UNIT_TENANT_HISTORY: 'unit_tenant_history',
  NOTIFICATIONS: 'notifications'
};
